// extracted by mini-css-extract-plugin
module.exports = {"text-positive":"_3g1b6nPdwiTIrSLFpxM7Ba","text-negative":"_3oMs6eCoQW3noEKRzSDsaB"};